import { After, ensureReady } from '@wkda/after-framework';
import { AppContainers, createReactQueryClient } from '@wkda/funnel-components';
import { initialize } from '@wkda/funnel-modules';
import { abSwitch } from '@wkda/funnel-utils';
import qs from 'query-string';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initRum } from '../shared/initRUM.js';
import { createClientLogger } from './createClientLogger.js';

/**
 *
 * @param {{
 *  config: import('@wkda/internal-types').IBaseAppConfig;
 *  routes: any;
 *  activateLocale: (locale: string) => void;
 * }} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function createClient({
  config,
  routes,
  activateLocale
}) {
  const {
    locale,
    features
  } = config;
  const apmLogger = initRum(config);
  const modules = initialize({
    configuration: config,
    waKey: process.env.WA_KEY,
    modulesLogger: createClientLogger(config, apmLogger),
    isServer: false
  });
  ensureReady(routes).then(data => {
    // @ts-expect-error
    const abTestingEnabled = abSwitch({
      query: qs.parse(window.location.search) || {}
    });
    const initialData = {
      ...(data?.initialData ?? {}),
      locale,
      abTestingEnabled
    };
    const queryClient = createReactQueryClient();

    // `ensureReady` reads the state serialized by <AfterData />, keep the
    // fallback in case that inline script never ran.
    const serverAppState = /** @type {import('@wkda/after-framework').ServerAppState} */
    data ?? {};

    // `After` forwards any extra prop into the ctx it passes to
    // `getInitialProps`, but `AfterpartyProps` does not declare them.
    const ctxProps = {
      locale,
      appConfig: config,
      modules,
      features,
      abTestingEnabled,
      queryClient
    };
    return hydrateRoot(document.getElementById('root'), /*#__PURE__*/_jsx(BrowserRouter, {
      children: /*#__PURE__*/_jsx(AppContainers, {
        appConfig: config,
        locale: locale,
        features: features,
        initialData: initialData,
        modules: modules,
        activateLocale: activateLocale,
        queryClient: queryClient,
        children: /*#__PURE__*/_jsx(After, {
          data: serverAppState,
          routes: routes,
          transitionBehavior: "blocking",
          ...ctxProps
        })
      })
    }));
  });
}